import { Fragment } from 'react'
import { FormattedMessage } from 'react-intl'
import ReactTooltip from 'react-tooltip'
import { PriceConverter } from '../../../helpers'

export const CouponDiscountValue = ({ item }) => {
  if(!item) {
    return null
  }

  const { valueDiscount, currency, valueKind, customBenefit } = item
  if(valueKind === 10) {
    return (
      <span>
        - <PriceConverter amount={valueDiscount} currency={currency} />
      </span>
    )
  }

  if(valueKind === 20) {
    return <span>- {valueDiscount}%</span>
  }

  if(valueKind === 30) {
    return (
      <FormattedMessage
        id='free_nigts_coupon'
        values={{ qty: valueDiscount }}
        defaultMessage='Free { qty, plural, one {# night} other {# nights}}'
      />
    )
  }

  return <span>- {customBenefit}%</span>
}

const CoupounItem = ({ item, onCouponRemove }) => {
  const { title, description } = item
  return (
    <Fragment>
      <div className='price-pan__body__row'>
        <ReactTooltip effect='solid' type='dark' />
        <div className='title flex'>
          <span className='tooltip-wrapper-block' data-tip={description}>
            {title}
            {description && <i className='font-icons info-icon' />}
          </span>
        </div>
        <div className='total-price green'>
          <CouponDiscountValue item={item} />
        </div>
      </div>

      {onCouponRemove && (
        <div className='price-pan__body__row'>
          <div className='title'>
            <a className='remove' onClick={onCouponRemove}>
              <FormattedMessage
                id='remove_coupon'
                defaultMessage='Remove coupon'
              />
            </a>
          </div>
        </div>
      )}
    </Fragment>
  )
}
export default CoupounItem
